import api from '../api/axios'
import customAxios from 'axios';

const discount = {
    async createDiscount(payloads) {
        let url = `/v1/admin/create_discount`
        return api.post(url, payloads)
    },

    async updateDiscount(oldCode, payloads) {
        let url = `/v1/admin/update_discount?oldCode=${oldCode}`

        return api.post(url, payloads)
    },

    async deleteDiscount(code) {
        let url = `/v1/admin/delete_discount?code=${code}`

        return api.post(url)
    },

    async getDiscountList(payloads) {

        let url = `/v1/admin/get_discount_lists`

        return api.post(url, payloads)
        
    }
}

export default discount


// WEBPACK FOOTER //
// ./src/api/discount.js